import { render } from "./TrailerPlateVinVerification.vue?vue&type=template&id=7e38a225&scoped=true&ts=true"
import script from "./TrailerPlateVinVerification.vue?vue&type=script&lang=ts"
export * from "./TrailerPlateVinVerification.vue?vue&type=script&lang=ts"

import "./TrailerPlateVinVerification.vue?vue&type=style&index=0&id=7e38a225&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e38a225"]])

export default __exports__